import { supabase } from '../lib/supabase-client'

// Custom Supabase backend for i18next
class SupabaseBackend {
  constructor(services, backendOptions = {}) {
    this.init(services, backendOptions)
  }

  init(services, backendOptions = {}) {
    this.services = services
    this.options = backendOptions
  }

  async read(language, namespace, callback) {
    // Endast ladda översättningar i browser-miljö
    if (typeof window === 'undefined') {
      if (process.env.NODE_ENV === 'development') {
        console.log('SupabaseBackend: Skipping server-side rendering')
      }
      callback(null, {}) // Returnera tom data för SSR
      return
    }

    try {
      if (process.env.NODE_ENV === 'development') {
        console.log(`Loading translations for language: ${language}, namespace: ${namespace}`)
      }
      
      const { data: translations, error } = await supabase
        .from('translations')
        .select('key, value')
        .eq('language', language)
      
      if (error) {
        if (error.message === 'Supabase not configured') {
          console.warn('SupabaseBackend: Supabase not configured, using empty translations')
          callback(null, {})
          return
        }
        console.error('Error loading translations from Supabase:', error)
        callback(null, {}) // Returnera tom data istället för fel
        return
      }
      
      // Konvertera till nested objekt struktur
      const translationObject = {}
      
      for (const translation of translations) {
        const { key, value } = translation
        const keyParts = key.split('.')
        let current = translationObject
        
        for (let i = 0; i < keyParts.length - 1; i++) {
          if (!current[keyParts[i]]) {
            current[keyParts[i]] = {}
          }
          current = current[keyParts[i]]
        }
        
        // Sätt värdet, försök parsa JSON om det är en array eller objekt
        try {
          // Rensa potentiellt korrupt JSON med förstärkt rensning
          // eslint-disable-next-line no-control-regex
          let cleanedValue = value.replace(/[\u0000-\u001F\u007F-\u009F]/g, '');
          
          // Ytterligare rensning för problematiska tecken
          cleanedValue = cleanedValue.replace(/[\uFFFD\uFEFF]/g, ''); // BOM och replacement characters
          cleanedValue = cleanedValue.replace(/[^\x20-\x7E\u00A0-\uFFFF]/g, ''); // Behåll endast printable characters
          
          current[keyParts[keyParts.length - 1]] = JSON.parse(cleanedValue)
        } catch {
          current[keyParts[keyParts.length - 1]] = value
        }
      }
      
      if (process.env.NODE_ENV === 'development') {
        console.log(`Loaded ${translations.length} translations for ${language}`)
      }
      callback(null, translationObject)
      
    } catch (error) {
      if (error.message === 'Supabase not configured') {
        console.warn('SupabaseBackend: Supabase not configured, using empty translations')
      } else {
        console.error('Error in SupabaseBackend:', error)
      }
      callback(null, {}) // Returnera tom data istället för fel
    }
  }
}

SupabaseBackend.type = 'backend'

export default SupabaseBackend
